import WooCommerceAPI from 'woocommerce-api'
// const API = "https://veki.pl";
const API = "https://devveki.ctit.pl";
// const API =  "http://localhost";
class WcApi {
  install(Vue) {
    Vue.prototype.$wcApi = this;

    this._wcApi = new WooCommerceAPI({
      url: API,
      consumerKey: 'ck_03cfe3e1b5355fa6149cf49eb3e8076196e5a50c',
      consumerSecret: 'cs_ddc3f07694a118899d758f4b1bb42ef591ba9d1c',
      wpAPI: true,
      version: 'wc/v3',
      timeout: 120000
    });
  }

  fetchCustomer(id) {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync(`customers/${id}`, function (err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  updateCustomer(id, data) {
    return new Promise((resolve, reject) => {
      this._wcApi.put(`customers/${id}`, data, function (err, data, res) {
        if (err !== null) {
          reject(false);
        }
        resolve(true);
      });
    });
  }

  fetchCustomerOrders(id, page) {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync(`orders?page=${page}&customer=${id}`, function (err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  fetchCustomerDownloads(id, page) {
    const that = this;
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync(`orders?page=${page}&customer=${id}`, function (err, data, res) {
        if (err !== null) {
          reject(err);
        }
        let promises = [];
        let products = [];
        const tmp = JSON.parse(res);
        for (let i = 0; i < tmp.length; i++) {
          products = products.concat(tmp[i].line_items);
        }
        for (let i = 0; i < products.length; i++) {
          const product = products[i];
          promises.push(
            new Promise((resolve, reject) => {
              that._wcApi.getAsync(`products/${product.product_id}`, function (err, data, res) {
                if (err !== null) {
                  reject(err);
                }
                resolve(JSON.parse(res));
              })
            })
          )
        }
        Promise.all(promises).then(function (values) {
          let response = [];
          for (let i = 0; i < values.length; i++) {
            const product = values[i];
            if (typeof product.downloads !== 'undefined' && product.downloads.length > 0) {
              response.push(product.downloads);
            }
          }
          resolve(response);
        });
      });
    });
  }

  fetchCustomerOrder(id) {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync(`orders/${id}`, function (err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  fetchTags() {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync('products/tags?per_page=100', function (err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  fetchCategories() {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync('products/categories?per_page=100', function (err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  fetchCategory(name) {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync(`products/categories?search=${name}`, function (err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  fetchTag(name) {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync(`products/tags?slug=${name}`, function (err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  fetchCategoriesByName(name) {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync(`products/categories?per_page=100&search=${name}`, function (err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  fetchShippingZones() {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync(`shipping/zones`, function(err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  fetchShippingZonesLocations(id) {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync(`shipping/zones/${id}/locations`, function(err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  fetchShippingZonesMethods(id) {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync(`shipping/zones/${id}/methods`, function(err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  fetchShippingMethod(id) {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync(`shipping_methods/${id}`, function(err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  fetchPaymentGateways() {
    return new Promise((resolve, reject) => {
      this._wcApi.getAsync(`payment_gateways`, function(err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  placeOrder(data) {
    return new Promise((resolve, reject) => {
      this._wcApi.post(`orders`, data, function(err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  fetchOrder(id) {
    return new Promise((resolve, reject) => {
      this._wcApi.get(`orders/${id}`, function(err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }

  cancelOrder(id, data) {
    return new Promise((resolve, reject) => {
      this._wcApi.put(`orders/${id}`, data, function(err, data, res) {
        if (err !== null) {
          reject(err);
        }
        resolve(JSON.parse(res));
      });
    });
  }
}

export default WcApi;
